import React from "react";

import { logger } from "../../lib/utils/logger/logger";
import { IDCheckLoopResponse, VerificationService } from "../../lib/types/types";
import { VerificationStepsEnum } from "../../lib/types/runtimeTypes";

interface IDCheckLoopComponentProps {
  verificationService: VerificationService;
}

const CONTAINER_ID = "onfido";

const IDCheckLoop = ({ verificationService }: IDCheckLoopComponentProps) => {
  const verificationResponse = verificationService.verificationResponse as IDCheckLoopResponse;

  const submitIdCheckLoop = (data: unknown) => {
    logger.info("StepIDCheckLoop submitting ID Check Loop", data);
    verificationService.submitStep(
      VerificationStepsEnum.idCheckLoop,
      verificationService.viewModel,
      verificationService.verificationResponse,
    );
  };

  const initializeOnfido = async () => {
    // Onfido needs to be loaded asynchronously to avoid test failures
    import("onfido-sdk-ui").then((Onfido) => {
      Onfido.init({
        containerId: CONTAINER_ID,
        token: verificationResponse.sdkToken,
        onComplete: (data) => {
          submitIdCheckLoop(data);
        },
        steps: ["document", { type: "face", options: { requestedVariant: "motion" } }, "complete"],
      });
    });
  };

  React.useEffect(() => {
    initializeOnfido();
  }, []);

  return <div id={CONTAINER_ID} />;
};

export const IDCheckLoopComponent = IDCheckLoop;
